import { blue } from '@ant-design/colors'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, ButtonProps } from 'antd'

export type Props = Exclude<ButtonProps, 'type'>
export const UndeleteButton = (props: Props) => {
  return <Button style={{color: blue.primary}} icon={<FontAwesomeIcon icon={faTrashUndo} />} {...props} type="text" />
}